exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cantidad {\n  width: 100%;\n  height: 40px;\n  border: 1px solid #d1d1d2;\n  border-radius: 5px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 0 10px; }\n\ninput.main-input {\n  border: none; }\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0; }\n\ninput[type=number] {\n  -moz-appearance: textfield; }\n\n.err-box {\n  color: #ff6767;\n  min-height: 50px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/common/agris-cantidad-selector/agris-cantidad-selector.component.scss
// module id = ../../../../../src/app/components/agris/common/agris-cantidad-selector/agris-cantidad-selector.component.scss
// module chunks = 0